__turbopack_context__.v({
  "arrowIconContainer": "_7senVW_arrowIconContainer",
  "arrowIconSmall": "_7senVW_arrowIconSmall",
  "arrowIconSmallOpen": "_7senVW_arrowIconSmallOpen",
  "chipContainer": "_7senVW_chipContainer",
  "dialog": "_7senVW_dialog",
  "dialogBody": "_7senVW_dialogBody",
  "dropdownButton": "_7senVW_dropdownButton",
  "removeButton": "_7senVW_removeButton",
  "seeAllButton": "_7senVW_seeAllButton",
  "shopIcon": "_7senVW_shopIcon",
  "shopList": "_7senVW_shopList",
  "shopListItemCopy": "_7senVW_shopListItemCopy",
  "value": "_7senVW_value",
});
